<template>
    <v-btn :loading="savingProduct" :disabled="checkIfSaved() || disabledSaveBtn" depressed color="primary" width="100%" @click="saveCurrentConfigurator();">{{$t('saveConfigurationLabel')}}</v-btn>
    <!-- <input type="submit" value="Save current configuration" @click="saveCurrentConfigurator();"> -->
</template>
<script>
import Vue from 'vue';
import productConfigurationService from '../../../services/Configurator/ProductConfigurationService';
import { mapGetters, mapActions } from 'vuex';
export default Vue.extend({  
    name: 'SaveCurrentConfiguration',
    data() {
        return {
            savingProduct: false,
        }
    },
    props:{
        disabledSaveBtn: Boolean
    },
    computed : {
         ...mapGetters('configuratorModule', ['getCurrentDoorConfiguration']),
    },
    methods : {
        ...mapActions('configuratorModule', ['setProductId']),
        checkIfSaved(){
            if(this.$store.state.configurationChanged){
                return false
            }
            else{
                return true
            }
        },
         saveCurrentConfigurator()
         {
             const vue = this
             this.savingProduct = true
              NProgress.start();
              productConfigurationService.saveCurrentProductConfigurator(this.getCurrentDoorConfiguration).then(( response )=> {
                  if(response.data !== ""){
                      console.log(response.data);
                       this.setProductId(response.data.id);
                       this.$store.dispatch('storeCurrentProduct',response.data);
                  }
                  NProgress.done();
                  this.savingProduct = false
                  this.$store.dispatch('setConfigurationStatus',false)
              });
         }
    }
});
</script>